export type ThemeColors = {
  success: {
    [x: string]: string;
  };
  warning: {
    [x: string]: string;
  };
  error: {
    [x: string]: string;
  };
  gray: {
    [x: string]: string;
  };
  indigo: {
    [x: string]: string;
  };
  black: string;
  white: string;
  TEDRed: string;
};

export default {
  success: { 0: '#26a65b', 1: '#e0f2e8' },
  warning: { 0: '#e5af0a', 1: '#faf0cf' },
  error: { 0: '#d91e18', 1: '#ffeeef' },
  gray: {
    0: '#252b36',
    1: '#3a4354',
    2: '#596781',
    3: '#7f8da7',
    4: '#9da8bc',
    5: '#d9dde5',
    6: '#e8ebef',
    7: '#f7f8fa',
  },
  indigo: {
    0: '#262d5e',
    1: '#323a7b',
    2: '#454ea4',
    3: '#5762d5',
    4: '#858ede',
    5: '#a6ade7',
    6: '#d8dbf4',
    7: '#ecedfa',
  },
  black: '#1b1f27',
  white: '#ffffff',
  TEDRed: '#e62b1e',
};
